<template>
  <main class="content overview">
      <section class="heading has-padding">
        <h1>{{this.$store.state.facilities_inspection.ANL_BEZEICHNUNG}}</h1>
      </section>

        <section class="form has-padding">
            <h2>Zustandsermittlung</h2>
            <div class="field field-m">
                <header class="is-flex">
                    <div class="col-2">
                        <label class="label">{{ $store.state.check_durchlass[0].name }}</label>
                    </div>
                    <div class="col-2 align-right">
                        <a @click="goToPath('massnahme_durchlass/' + $store.state.check_durchlass[0].id, $event)" class="link">
                            <span v-if="this.$store.state.check_durchlass[0].is_action_added">1</span> 
                            Maßnahme
                        </a>
                    </div>
                </header>
                
                <div class="custom-select is-flex" :class="{block_Edit: !this.$store.state.is_Edit_active}">
                    <div v-for="(val, idx) in $store.state.check_durchlass[0].values" 
                        @click="checkClick($store.state.check_durchlass[0], val)"
                        :key="'v-' + idx"
                        :class="{ active: $store.state.check_durchlass[0].selected_value == val }"
                        class="col-5 is-flex" 
                        >
                        <h4>{{ val }}</h4>
                    </div>
                </div>

                <footer class="is-flex">
                    <div class="col-2">
                        <p>Gut (kein, nicht)</p>
                    </div>
                    <div class="col-2 align-right">
                        <p>Schlecht (sehr stark)</p>
                    </div>
                </footer>
            </div>

            <div class="field">
                <header class="is-flex">
                    <div class="col-2">
                        <label class="label">{{ $store.state.check_durchlass[1].name }}</label>
                    </div>
                    <div class="col-2 align-right">
                        <a @click="goToPath('massnahme_durchlass/' + $store.state.check_durchlass[1].id, $event)" class="link">
                            <span v-if="this.$store.state.check_durchlass[1].is_action_added">1</span> 
                            Maßnahme
                        </a>
                    </div>
                </header>
                
                <div class="custom-select is-flex" :class="{block_Edit: !this.$store.state.is_Edit_active}">
                    <div v-for="(val, idx) in $store.state.check_durchlass[1].values" 
                        @click="checkClick($store.state.check_durchlass[1], val)"
                        :key="'v-' + idx"
                        :class="{ active: $store.state.check_durchlass[1].selected_value == val }"
                        class="col-5 is-flex" 
                        >
                        <h4>{{ val }}</h4>
                    </div>
                </div>

                <footer class="is-flex">
                    <div class="col-2">
                        <p>Gut (kein, nicht)</p>
                    </div>
                    <div class="col-2 align-right">
                        <p>Schlecht (sehr stark)</p>
                    </div>
                </footer>
            </div>

            <div class="field">
                <header class="is-flex">
                    <div class="col-2">
                        <label class="label">{{ $store.state.check_durchlass[2].name }}</label>
                    </div>
                    <div class="col-2 align-right">
                        <a @click="goToPath('massnahme_durchlass/' + $store.state.check_durchlass[2].id, $event)" class="link">
                            <span v-if="this.$store.state.check_durchlass[2].is_action_added">1</span> 
                            Maßnahme
                        </a>
                    </div>
                </header>
                
                <div class="custom-select is-flex" :class="{block_Edit: !this.$store.state.is_Edit_active}">
                    <div v-for="(val, idx) in $store.state.check_durchlass[2].values" 
                        @click="checkClick($store.state.check_durchlass[2], val)"
                        :key="'v-' + idx"
                        :class="{ active: $store.state.check_durchlass[2].selected_value == val }"
                        class="col-5 is-flex" 
                        >
                        <h4>{{ val }}</h4>
                    </div>
                </div>

                <footer class="is-flex">
                    <div class="col-2">
                        <p>Gut (kein, nicht)</p>
                    </div>
                    <div class="col-2 align-right">
                        <p>Schlecht (sehr stark)</p>
                    </div>
                </footer>
            </div>

            <div class="field">
                <header class="is-flex">
                    <div class="col-2">
                        <label class="label">{{ $store.state.check_durchlass[3].name }}</label>
                    </div>
                    <div class="col-2 align-right">
                        <a @click="goToPath('massnahme_durchlass/' + $store.state.check_durchlass[3].id, $event)" class="link">
                            <span v-if="this.$store.state.check_durchlass[3].is_action_added">1</span> 
                            Maßnahme
                        </a>
                    </div>
                </header>
                
                <div class="custom-select is-flex" :class="{block_Edit: !this.$store.state.is_Edit_active}">
                    <div v-for="(val, idx) in $store.state.check_durchlass[3].values" 
                        @click="checkClick($store.state.check_durchlass[3], val)"
                        :key="'v-' + idx"
                        :class="{ active: $store.state.check_durchlass[3].selected_value == val }"
                        class="col-5 is-flex" 
                        >
                        <h4>{{ val }}</h4>
                    </div>
                </div>

                <footer class="is-flex">
                    <div class="col-2">
                        <p>Gut (kein, nicht)</p>
                    </div>
                    <div class="col-2 align-right">
                        <p>Schlecht (sehr stark)</p>
                    </div>
                </footer>
            </div>

            <div class="field">
                <header class="is-flex">
                    <div class="col-2">
                        <label class="label">{{ $store.state.check_durchlass[4].name }}</label>
                    </div>
                    <div class="col-2 align-right">
                        <a @click="goToPath('massnahme_durchlass/' + $store.state.check_durchlass[4].id, $event)" class="link">
                            <span v-if="this.$store.state.check_durchlass[4].is_action_added">1</span> 
                            Maßnahme
                        </a>
                    </div>
                </header>
                <div class="custom-select is-flex" :class="{block_Edit: !this.$store.state.is_Edit_active}">
                    <div v-for="(val, idx) in $store.state.check_durchlass[4].values" 
                        @click="checkClick($store.state.check_durchlass[4], val)"
                        :key="'v-' + idx"
                        :class="{ active: $store.state.check_durchlass[4].selected_value == val }"
                        class="col-5 is-flex" 
                        >
                        <h4>{{ val }}</h4>
                    </div>
                </div>
                <footer class="is-flex">
                    <div class="col-2">
                        <p>Gut (kein, nicht)</p>
                    </div>
                    <div class="col-2 align-right">
                        <p>Schlecht (sehr stark)</p>
                    </div>
                </footer>
            </div>

            <div class="field">
                <header class="is-flex">
                    <div class="col-2">
                        <label class="label">{{ $store.state.check_durchlass[5].name }}</label>
                    </div>
                    <div class="col-2 align-right">
                        <a @click="goToPath('massnahme_durchlass/' + $store.state.check_durchlass[5].id, $event)" class="link">
                            <span v-if="this.$store.state.check_durchlass[5].is_action_added">1</span> 
                            Maßnahme
                        </a>
                    </div>
                </header>
                
                <div class="custom-select is-flex" :class="{block_Edit: !this.$store.state.is_Edit_active}">
                    <div v-for="(val, idx) in $store.state.check_durchlass[5].values" 
                        @click="checkClick($store.state.check_durchlass[5], val)"
                        :key="'v-' + idx"
                        :class="{ active: $store.state.check_durchlass[5].selected_value == val }"
                        class="col-5 is-flex" 
                        >
                        <h4>{{ val }}</h4>
                    </div>
                </div>

                <footer class="is-flex">
                    <div class="col-2">
                        <p>Gut (kein, nicht)</p>
                    </div>
                    <div class="col-2 align-right">
                        <p>Schlecht (sehr stark)</p>
                    </div>
                </footer>
            </div>

            <div class="field">
                <header class="is-flex">
                    <div class="col-2">
                        <label class="label">{{ $store.state.check_durchlass[6].name }}</label>
                    </div>
                    <div class="col-2 align-right">
                        <a @click="goToPath('massnahme_durchlass/' + $store.state.check_durchlass[6].id, $event)" class="link">
                            <span v-if="this.$store.state.check_durchlass[6].is_action_added">1</span> 
                            Maßnahme
                        </a>
                    </div>
                </header>
                
                <div class="custom-select is-flex" :class="{block_Edit: !this.$store.state.is_Edit_active}">
                    <div v-for="(val, idx) in $store.state.check_durchlass[6].values" 
                        @click="checkClick($store.state.check_durchlass[6], val)"
                        :key="'v-' + idx"
                        :class="{ active: $store.state.check_durchlass[6].selected_value == val }"
                        class="col-3 is-flex" 
                        >
                        <h4>{{ val }}</h4>
                    </div>
                </div>

                <footer class="is-flex">
                    <div class="col-2">
                        <p>Gut (kein, nicht)</p>
                    </div>
                    <div class="col-2 align-right">
                        <p>Schlecht (sehr stark)</p>
                    </div>
                </footer>
            </div>

            <div class="field">
                <header class="is-flex">
                    <div class="col-2">
                        <label class="label">{{ $store.state.check_durchlass[7].name }}</label>
                    </div>
                    <div class="col-2 align-right">
                        <a @click="goToPath('massnahme_durchlass/' + $store.state.check_durchlass[7].id, $event)" class="link">
                            <span v-if="this.$store.state.check_durchlass[7].is_action_added">1</span> 
                            Maßnahme
                        </a>
                    </div>
                </header>
                
                <div class="custom-select is-flex" :class="{block_Edit: !this.$store.state.is_Edit_active}">
                    <div v-for="(val, idx) in $store.state.check_durchlass[7].values" 
                        @click="checkClick($store.state.check_durchlass[7], val)"
                        :key="'v-' + idx"
                        :class="{ active: $store.state.check_durchlass[7].selected_value == val }"
                        class="col-3 is-flex" 
                        >
                        <h4>{{ val }}</h4>
                    </div>
                </div>

                <footer class="is-flex">
                    <div class="col-2">
                        <p>Gut (kein, nicht)</p>
                    </div>
                    <div class="col-2 align-right">
                        <p>Schlecht (sehr stark)</p>
                    </div>
                </footer>
            </div>

            <div class="field">
                <header class="is-flex">
                    <div class="col-2">
                        <label class="label">{{ $store.state.check_durchlass[8].name }}</label>
                    </div>
                    <div class="col-2 align-right">
                        <a @click="goToPath('massnahme_durchlass/' + $store.state.check_durchlass[8].id, $event)" class="link">
                            <span v-if="this.$store.state.check_durchlass[8].is_action_added">1</span> 
                            Maßnahme
                        </a>
                    </div>
                </header>
                
                <div class="custom-select is-flex" :class="{block_Edit: !this.$store.state.is_Edit_active}">
                    <div v-for="(val, idx) in $store.state.check_durchlass[8].values" 
                        @click="checkClick($store.state.check_durchlass[8], val)"
                        :key="'v-' + idx"
                        :class="{ active: $store.state.check_durchlass[8].selected_value == val }"
                        class="col-3 is-flex" 
                        >
                        <h4>{{ val }}</h4>
                    </div>
                </div>

                <footer class="is-flex">
                    <div class="col-2">
                        <p>Gut (kein, nicht)</p>
                    </div>
                    <div class="col-2 align-right">
                        <p>Schlecht (sehr stark)</p>
                    </div>
                </footer>
            </div>

            <div class="field">
                <header class="is-flex">
                    <div class="col-2">
                        <label class="label">{{ $store.state.check_durchlass[9].name }}</label>
                    </div>
                    <div class="col-2 align-right">
                        <a @click="goToPath('massnahme_durchlass/' + $store.state.check_durchlass[9].id, $event)" class="link">
                            <span v-if="this.$store.state.check_durchlass[9].is_action_added">1</span> 
                            Maßnahme
                        </a>
                    </div>
                </header>
                
                <div class="custom-select is-flex" :class="{block_Edit: !this.$store.state.is_Edit_active}">
                    <div v-for="(val, idx) in $store.state.check_durchlass[9].values" 
                        @click="checkClick($store.state.check_durchlass[9], val)"
                        :key="'v-' + idx"
                        :class="{ active: $store.state.check_durchlass[9].selected_value == val }"
                        class="col-3 is-flex" 
                        >
                        <h4>{{ val }}</h4>
                    </div>
                </div>

                <footer class="is-flex">
                    <div class="col-2">
                        <p>Gut (kein, nicht)</p>
                    </div>
                    <div class="col-2 align-right">
                        <p>Schlecht (sehr stark)</p>
                    </div>
                </footer>
            </div>

            <div class="field">
                <header class="is-flex">
                    <div class="col-2">
                        <label class="label">{{ $store.state.check_durchlass[10].name }}</label>
                    </div>
                    <div class="col-2 align-right">
                        <a @click="goToPath('massnahme_durchlass/' + $store.state.check_durchlass[10].id, $event)" class="link">
                            <span v-if="this.$store.state.check_durchlass[10].is_action_added">1</span> 
                            Maßnahme
                        </a>
                    </div>
                </header>
                
                <div class="custom-select is-flex" :class="{block_Edit: !this.$store.state.is_Edit_active}">
                    <div v-for="(val, idx) in $store.state.check_durchlass[10].values" 
                        @click="checkClick($store.state.check_durchlass[10], val)"
                        :key="'v-' + idx"
                        :class="{ active: $store.state.check_durchlass[10].selected_value == val }"
                        class="col-3 is-flex" 
                        >
                        <h4>{{ val }}</h4>
                    </div>
                </div>

                <footer class="is-flex">
                    <div class="col-2">
                        <p>Gut (kein, nicht)</p>
                    </div>
                    <div class="col-2 align-right">
                        <p>Schlecht (sehr stark)</p>
                    </div>
                </footer>
            </div>

            <div class="field">
                <header class="is-flex">
                    <div class="col-2">
                        <label class="label">{{ $store.state.check_durchlass[11].name }}</label>
                    </div>
                    <div class="col-2 align-right">
                        <a @click="goToPath('massnahme_durchlass/' + $store.state.check_durchlass[11].id, $event)" class="link">
                            <span v-if="this.$store.state.check_durchlass[11].is_action_added">1</span> 
                            Maßnahme
                        </a>
                    </div>
                </header>
                
                <div class="custom-select is-flex" :class="{block_Edit: !this.$store.state.is_Edit_active}">
                    <div v-for="(val, idx) in $store.state.check_durchlass[11].values" 
                        @click="checkClick($store.state.check_durchlass[11], val)"
                        :key="'v-' + idx"
                        :class="{ active: $store.state.check_durchlass[11].selected_value == val }"
                        class="col-3 is-flex" 
                        >
                        <h4>{{ val }}</h4>
                    </div>
                </div>

                <footer class="is-flex">
                    <div class="col-2">
                        <p>Gut (kein, nicht)</p>
                    </div>
                    <div class="col-2 align-right">
                        <p>Schlecht (sehr stark)</p>
                    </div>
                </footer>
            </div>

            <div class="field">
                <header class="is-flex">
                    <div class="col-2">
                        <label class="label">{{ $store.state.check_durchlass[12].name }}</label>
                    </div>
                    <div class="col-2 align-right">
                        <a @click="goToPath('massnahme_durchlass/' + $store.state.check_durchlass[12].id, $event)" class="link">
                            <span v-if="this.$store.state.check_durchlass[12].is_action_added">1</span> 
                            Maßnahme
                        </a>
                    </div>
                </header>
                
                <div class="custom-select is-flex" :class="{block_Edit: !this.$store.state.is_Edit_active}">
                    <div v-for="(val, idx) in $store.state.check_durchlass[12].values" 
                        @click="checkClick($store.state.check_durchlass[12], val)"
                        :key="'v-' + idx"
                        :class="{ active: $store.state.check_durchlass[12].selected_value == val }"
                        class="col-3 is-flex" 
                        >
                        <h4>{{ val }}</h4>
                    </div>
                </div>

                <footer class="is-flex">
                    <div class="col-2">
                        <p>Gut (kein, nicht)</p>
                    </div>
                    <div class="col-2 align-right">
                        <p>Schlecht (sehr stark)</p>
                    </div>
                </footer>
            </div>

            <div class="field">
                <header class="is-flex">
                    <div class="col-2">
                        <label class="label">{{ $store.state.check_durchlass[13].name }}</label>
                    </div>
                    <div class="col-2 align-right">
                        <a @click="goToPath('massnahme_durchlass/' + $store.state.check_durchlass[13].id, $event)" class="link">
                            <span v-if="this.$store.state.check_durchlass[13].is_action_added">1</span> 
                            Maßnahme
                        </a>
                    </div>
                </header>
                
                <div class="custom-select is-flex" :class="{block_Edit: !this.$store.state.is_Edit_active}">
                    <div v-for="(val, idx) in $store.state.check_durchlass[13].values" 
                        @click="checkClick($store.state.check_durchlass[13], val)"
                        :key="'v-' + idx"
                        :class="{ active: $store.state.check_durchlass[13].selected_value == val }"
                        class="col-3 is-flex" 
                        >
                        <h4>{{ val }}</h4>
                    </div>
                </div>

                <footer class="is-flex">
                    <div class="col-2">
                        <p>Gut (kein, nicht)</p>
                    </div>
                    <div class="col-2 align-right">
                        <p>Schlecht (sehr stark)</p>
                    </div>
                </footer>
            </div>

            <h2 class="subline">Zustandsbeurteilung</h2>

            <div class="field">
                <label class="label">Zustandsklasse</label>
                <div class="select" :class="{block_Edit: !this.$store.state.is_Edit_active}">
                    <select v-model="stateClass">
                      <option disabled value="">Bitte auswählen</option>
                      <option 
                        v-for="(val, idx) in $store.state.facilities_inspection.stateClass_values" 
                        :key="'s' + idx"
                        :value="val"
                        >
                        {{ val }}
                      </option>
                    </select>
                    <i class="arrow down"></i>
                </div>
            </div>

            <div class="field">
                <label class="label">Zusatz</label>
                <div class="select" :class="{block_Edit: !this.$store.state.is_Edit_active}">
                    <select v-model="stateAdditive">
                      <option disabled value="">Bitte auswählen</option>
                      <option 
                        v-for="(val, idx) in $store.state.facilities_inspection.stateAdditive_values" 
                        :key="'s' + idx"
                        :value="val"
                        >
                        {{ val }}
                      </option>
                    </select>
                    <i class="arrow down"></i>
                </div>
            </div>

            <div class="field">
                <label class="label">Begründung Zusatz S</label>
                <textarea class="textarea" :class="{block_Edit: !this.$store.state.is_Edit_active}" placeholder="Beschreibung einfügen..." v-model="stateComment"></textarea>
            </div>

            </section>

            <section class="has-padding">
                <h2 class="subline adj">Betriebliche Maßnahmen</h2>
            </section>

            <div class="checkbox-select">
                <div class="checkbox" :class="{block_Edit: !this.$store.state.is_Edit_active}">
                    <h3>Langsam fahren</h3>
                    <div 
                        @click="setToggle_actionDriveSlowly()" 
                        class="toggle"
                        :class="{ active: $store.state.facilities_inspection.actionDriveSlowly }"
                    >
                        <div class="circle"></div>
                    </div>
                </div>
                <div class="checkbox" :class="{block_Edit: !this.$store.state.is_Edit_active}">
                    <h3>Streckensperre</h3>
                    <div 
                        @click="setToggle_trainrouteBlock()" 
                        class="toggle"
                        :class="{ active: $store.state.facilities_inspection.trainrouteBlock }"
                    >
                        <div class="circle"></div>
                    </div>
                </div>
            </div>

            <section class="has-padding padding-bottom">
                <div class="field adj">
                    <label class="label">Beschreibung</label>
                    <textarea class="textarea" :class="{block_Edit: !this.$store.state.is_Edit_active}" placeholder="Beschreibung einfügen..." v-model="actionComment"></textarea>
                </div>

                <h2 class="subline">Sonstige Anmerkungen / Fotos</h2>

                <div v-if="this.$store.state.is_Edit_active" class="field" :class="{block_Edit: !this.$store.state.is_Edit_active}">
                    <label class="label">Foto Upload - <strong>{{ this.$store.state.facilities_inspection.images.length }}</strong> Foto(s) wurde(n) upgeloaded</label>
                    <vue-dropzone
                        ref="myVueDropzone" 
                        id="dropzone" 
                        :options="dropzoneOptions"
                        :useCustomSlot=true
                        v-on:vdropzone-file-added="isPhotoUpload_finished = false"
                        v-on:vdropzone-success="getFiles"
                    >
                        <div class="dropzone-custom-content">
                            <a class="link">Fotos hochladen</a>
                        </div>
                    </vue-dropzone>
                </div>
                <div v-else class="field">
                    <label class="label">Foto Upload - <strong>{{ this.$store.state.facilities_inspection.images.length }}</strong> Foto(s) wurde(n) upgeloaded</label>
                    <div class="images is-flex">
                        <img v-for="(img, idx) in this.$store.state.facilities_inspection.images" :key="idx" :src="img.fullPath" alt="Bildupload">
                    </div>
                </div>

                <div class="field">
                    <label class="label">Anmerkungen</label>
                    <textarea class="textarea" :class="{block_Edit: !this.$store.state.is_Edit_active}" placeholder="Beschreibung einfügen..." v-model="comment"></textarea>
                </div>
            </section>

      <div v-if="this.$store.state.is_Edit_active" @click="fetch_POST_Inspection()" class="button is-primary is-flex" :class="{disable_Upload: !this.isPhotoUpload_finished}">
          <h3>Inspektion speichern</h3>
      </div>
  </main>
</template>

<script>
import axios from 'axios'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  name: 'inspektion_durchlass',
  components: {
    vueDropzone: vue2Dropzone
  },
  computed: {
    field_id_5: {
        get () {
            return this.$store.state.check_durchlass[4].action.selected_action
        },
        set (value) {
            this.$store.state.check_durchlass[4].action.selected_action = value
        }
    },
    stateClass: {
        get () {
            return this.$store.state.facilities_inspection.stateClass
        },
        set (value) {
            this.$store.state.facilities_inspection.stateClass = value
        }
    },
    stateAdditive: {
        get () {
            return this.$store.state.facilities_inspection.stateAdditive
        },
        set (value) {
            this.$store.state.facilities_inspection.stateAdditive = value
        }
    },
    stateComment: {
        get () {
            return this.$store.state.facilities_inspection.stateComment
        },
        set (value) {
            this.$store.state.facilities_inspection.stateComment = value
        }
    },
    actionComment: {
        get () {
            return this.$store.state.facilities_inspection.actionComment
        },
        set (value) {
            this.$store.state.facilities_inspection.actionComment = value
        }
    },
    comment: {
        get () {
            return this.$store.state.facilities_inspection.comment
        },
        set (value) {
            this.$store.state.facilities_inspection.comment = value
        }
    }
  },
  data() {
    return {
        dropzoneOptions: {
          url: 'https://www.lola-inspect.at/api/facilities/image',
          headers: { "Authorization": this.$store.state.authToken },
          addRemoveLinks: true,
        },
        isPhotoUpload_finished: true
    }
  },
  created () {
  },
  methods: {
    goToPath (route) {
        this.$router.push(route);
    },
    checkClick (store, val) {
        if (store.selected_value.length == 0) {
            store.selected_value = val
        } else if (store.selected_value == val) {
            store.selected_value = ''
        } else {
            store.selected_value = val
        }
    },
    setToggle_actionDriveSlowly () {
        this.$store.state.facilities_inspection.actionDriveSlowly = !this.$store.state.facilities_inspection.actionDriveSlowly
    },
    setToggle_trainrouteBlock () {
        this.$store.state.facilities_inspection.trainrouteBlock = !this.$store.state.facilities_inspection.trainrouteBlock
    },
    getFiles: function(file, response) {
        let imgObj = {}

        imgObj.filename = response.filename
        imgObj.fullPath = response.fullPath

        this.isPhotoUpload_finished = true
        this.$store.state.facilities_inspection.images.push(imgObj)
    },
    fetch_POST_Inspection () {
        this.$store.state.facilities_inspection.check = this.$store.state.check_durchlass

        axios({
            method: 'post',
            url: 'https://www.lola-inspect.at/api/facilities/inspection',
            headers: { Authorization: this.$store.state.authToken },
            data: this.$store.state.facilities_inspection
        })
        .then(function (response) {
            if (response.status === 200) {
                this.$store.state.was_Upload_successful = true
                console.log(response)
                this.$router.push('status')
            } else {
                this.$store.state.was_Upload_successful = false

                this.$router.push('status')
            }
        }.bind(this))
        .catch(function () {
            this.$store.state.was_Upload_successful = false

            this.$router.push('status')
        }.bind(this));
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.custom-select {
    width: 100%;

    .col-5 {
        width: 20%;
        height: 50px;
        background-color: var(--input-bg-color);
        text-align: center;
        position: relative;

        &:first-of-type {
            border-radius: 5px 0px 0px 5px;
        }

        &:nth-child(2) {
            background-color: rgba(195, 195, 195, .5);
        }

        &:nth-child(3) {
            background-color: rgba(195, 195, 195, .6);
        }

        &:nth-child(4) {
            background-color: rgba(195, 195, 195, .8);
        }

        &:last-of-type {
            border-radius: 0px 5px 5px 0px;
            background-color: rgba(195, 195, 195, 1);
        }

        &::before {
            transition: all .2s ease-in-out;
            width: 20px;
            height: 15px;
            margin-top: 15px;
            position: absolute;
            display: block;
            content: '';
            background-image: url('../assets/check_white.svg');
            background-repeat: no-repeat;
            background-size: contain;
            opacity: 0;
            visibility: hidden;
        }

        &.active {
            background-color: var(--main-color);
            color: #ffffff;

            h4 {
                visibility: hidden;
                opacity: 0;
            }

            &::before {
                visibility: visible;
                opacity: 1;
                margin-top: 0px;
            }
        }
    }

    .col-3 {
        width: 33.33333%;
        height: 50px;
        background-color: var(--input-bg-color);
        text-align: center;
        position: relative;
        transition: all .3s ease-in-out;

        &:first-of-type {
            border-radius: 5px 0px 0px 5px;
        }

        &:nth-child(2) {
            background-color: rgba(195, 195, 195, .5);
        }

        &:last-of-type {
            border-radius: 0px 5px 5px 0px;
            background-color: rgba(195, 195, 195, 1);
        }

        &::before {
            transition: all .2s ease-in-out;
            width: 20px;
            height: 15px;
            margin-top: 15px;
            position: absolute;
            display: block;
            content: '';
            background-image: url('../assets/check_white.svg');
            background-repeat: no-repeat;
            background-size: contain;
            opacity: 0;
            visibility: hidden;
        }

        &.active {
            background-color: var(--main-color);
            color: #ffffff;

            h4 {
                visibility: hidden;
                opacity: 0;
            }

            &::before {
                visibility: visible;
                opacity: 1;
                margin-top: 0px;
            }
        }
    }
}

.check-icon {
    width: 18px;
    height: auto;
    z-index: 90;
    margin-left: -0.35rem;
}

.field {
    footer {
        margin-top: 0.4rem;
    }
}

.checkbox {
    width: 100%;
    position: relative;
    background-color: rgba(255, 255, 255, 1);
    padding: 1rem var(--padding) 1rem var(--padding);
    border-bottom: 1px solid rgb(230, 230, 230);

    &:last-of-type {
        border-bottom: none;
    }

    .toggle {
        width: 68px;
        height: 72%;
        position: absolute;
        top: 0.45rem;
        border-radius: 100px;
        right: var(--padding);
        z-index: 90;
        background-color: var(--input-bg-color);
        display: flex;
        align-items: center;
        cursor: pointer;

        .circle {
            width: 35px;
            height: 86%;
            background-color: #ffffff;
            border-radius: 50%;
            position: absolute;
            left: 4px;
            box-shadow: 0px 2px 3px rgba(25, 25, 25, 0.25);
            transition: all 0.3s ease-in-out;
        }

        &.active {
            background-color: var(--main-color);
            
            .circle {
                left: 29px;
            }
        }
    }

    h3 {
        font-size: 1rem;
    }
}

.padding-bottom {
    padding-bottom: 140px;
}

header .col-2:last-of-type {
    margin-top: -7px!important;
}

.dropzone {
    background: var(--input-bg-color);
    padding: 10px 10px;
    border-radius: 5px;
}

#dropzone .link {
    margin-top: 18px;
}

a.dz-remove::after {
    background-color: #ffffff;
    display: none!important;
    opacity: 0;
}

.disable_Upload {
    background-color: rgba(140, 140, 140, 1);
    pointer-events: none;

    h3 {
        opacity: 0.5;
    }
}

@media all and (min-width: 640px) and (max-width: 1100px) {

}

@media (min-width: 780px) {
  .has-padding {
    max-width: var(--maxWidth);
    margin: 0 auto;
  }

  .checkbox {
    max-width: calc(var(--maxWidth) - var(--padding) * 2);
    margin: 0 auto;
    padding: 1rem 1rem;

    .toggle {
        right: 1rem;
    }
  }
}
</style>